export enum ITEM_QUALITIES {
  ARTIFACT = 6,
  LEGENDARY = 5,
  EPIC = 4,
  RARE = 3,
  UNCOMMON = 2,
  COMMON = 1,
  POOR = 0,
}
